import { render, staticRenderFns } from "./ResponsiveTab.vue?vue&type=template&id=019121ce&scoped=true"
import script from "./ResponsiveTab.vue?vue&type=script&lang=js"
export * from "./ResponsiveTab.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveTab.vue?vue&type=style&index=0&id=019121ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019121ce",
  null
  
)

export default component.exports